// extracted by mini-css-extract-plugin
export var dark = "bc_cL";
export var footnote = "bc_cS";
export var highlightLight = "bc_cQ";
export var light = "bc_cK";
export var lightToDark = "bc_cR";
export var tan = "bc_cn";